import React, { CSSProperties } from 'react';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import { styled } from '../../../../styles';

interface SelectIconProps {
  children: any;
  style?: CSSProperties;
  className?: string;
  variant?: 'chip' | 'small' | 'medium';
}

export const SelectIconWrapper: React.FC<React.PropsWithChildren<SelectIconProps>> = ({
  children,
  style,
  className,
  variant = 'medium'
}) => (
  <StyledListItemAvatar style={style} className={className} {...getSize(variant)}>
    {children}
  </StyledListItemAvatar>
);

const StyledListItemAvatar = styled(ListItemAvatar)<{ $minWidth: string; $size: string }>`
  && {
    min-width: ${({ $minWidth }) => $minWidth};
    vertical-align: middle;
    display: flex;
    align-items: center;
      
    .MuiAvatar-root {
        height: ${({ $size }) => $size} !important;
        width: ${({ $size }) => $size} !important;
    }  

  }
`;

function getSize(variant: SelectIconProps['variant']) {
  switch (variant) {
    case 'chip':
      return {
        $minWidth: '22px',
        $size: '18px'
      };
    case 'small':
      return {
        $minWidth: '30px',
        $size: '24px'
      };
    default:
      return {
        $minWidth: '48px',
        $size: '38px'
      };
  }
}
